import { render, staticRenderFns } from "./MyNotificationsPage.vue?vue&type=template&id=014ef3c2&scoped=true"
import script from "./MyNotificationsPage.vue?vue&type=script&lang=js"
export * from "./MyNotificationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ef3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014ef3c2')) {
      api.createRecord('014ef3c2', component.options)
    } else {
      api.reload('014ef3c2', component.options)
    }
    module.hot.accept("./MyNotificationsPage.vue?vue&type=template&id=014ef3c2&scoped=true", function () {
      api.rerender('014ef3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/notifications/MyNotificationsPage.vue"
export default component.exports